import { Tooltip } from 'antd'

import { INDUCTION_STATUSES } from './constants'

import { Tag } from '@/components/shared-components/BUI/Tag'

import { InductionStatus } from 'types/api.graphql'

type Props = {
  status: InductionStatus
}

export const InductionTag: React.FC<Props> = ({ status }) => {
  const tagInfo = INDUCTION_STATUSES[status]

  if (!tagInfo) return null

  return (
    <Tag
      size="small"
      label={tagInfo.label}
      variant={tagInfo.variant}
      icon={tagInfo.icon}
    />
  )
}

export const IconOnlyInductionTag: React.FC<Props> = ({ status }) => {
  const tagInfo = INDUCTION_STATUSES[status]

  if (!tagInfo) return null

  return (
    <Tooltip title={tagInfo.label}>
      <Tag
        size="small"
        label={null}
        variant={tagInfo.variant}
        icon={tagInfo.icon}
      />
    </Tooltip>
  )
}
